import * as algoliasearch from 'algoliasearch';

const client = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_KEY);
const stockIndex = client.initIndex(`${process.env.ENV_SHORTNAME}_stocks`);

const state = {
  globalStocks: readJSON('stocks'),
  stockListIndex: null,
  stockItem: null,
  openedIndex: null,
  refreshSearch: false,
  editingStock: null,
  results: {
    limit: 50,
    page: 0,
    totalPages: 0,
    totalRecords: 0,
    facets: readJSON('facets'),
  },
  defaultFacets: readJSON('defaultFacets'),
  sortBy: {
    productName: 'sort',
    brandName: 'sort',
  },
  keywords: ' ',
  facetFilters: [],
  stockIndex,
};

const mutations = {
  UPDATE_STOCK_LIST(state, payload) {
    if (payload && payload.index) {
      state.globalStocks.splice(payload.index, 1);
      storeJSON(state.globalStocks, 'stocks', 'deleteStock');
      state.results.totalRecords -= 1;
    } else if (payload && payload.stock) {
      state.globalStocks.map((stock, index) => {
        if (stock.objectID === payload.stock.objectID) {
          state.globalStocks[index] = payload.stock;
        }
      });
      storeJSON(state.globalStocks, 'stocks', 'updateStock');
    } else {
      state.stockListIndex = null;
      state.stockItem = null;
    }
  },
  SET_GLOBAL_STOCKS(state, stocks) {
    state.globalStocks = stocks;
    storeJSON(state.globalStocks, 'stocks', 'setGlobal');
  },
  TOGGLE_TABLE_VIEW(state, index) {
    index !== null ? state.editingStock = state.globalStocks[index] : state.editingStock = null;
    state.openedIndex = index;
  },
  TRIGGER_NEW_SEARCH(state) {
    state.refreshSearch = !state.refreshSearch;
  },
  SEARCH_STOCKS(state, payload) {
    payload && payload.page !== null ? state.results.page = payload.page : null;
    stockIndex.search(
      {
        query: payload && payload.keywords ? payload.keywords : state.keywords,
        facets: ['*'],
        facetFilters: state.facetFilters,
        page: state.results.page,
        hitsPerPage: state.results.limit,
      },
      (err, content) => {
        if (err) throw err;
        // Update product results
        state.globalStocks = content.hits;
        storeJSON(state.globalStocks, 'stocks', 'algolia');
        // Update total pages
        state.results.totalPages = content.nbPages;
        state.results.page = content.page;
        state.results.totalRecords = content.nbHits;
        // Store facets only if results found
        if (content.nbHits) {
          state.results.facets = content.facets;
          storeJSON(content.facets, 'facets', 'facets');
        }

        if (payload && payload.firstSearch) {
          state.defaultFacets = content.facets;
          storeJSON(content.facets, 'defaultFacets', 'defaultFacets');
        }
      },
    );
  },
  UPDATE_KEYWORD(state, value) {
    state.keywords = value;
  },
  UPDATE_FACET_FILTERS(state, value) {
    state.facetFilters = value;
  },
};

const actions = {
  updateStockList({ commit }, payload) {
    commit('UPDATE_STOCK_LIST', payload);
  },
  setGlobalStocks({ commit }, stocks) {
    commit('SET_GLOBAL_STOCKS', stocks);
  },
  toggleTableView({ commit }, index) {
    commit('TOGGLE_TABLE_VIEW', index);
  },
  triggerNewSearch({ commit }) {
    commit('TRIGGER_NEW_SEARCH');
  },
  searchStocks({ commit }, payload) {
    commit('SEARCH_STOCKS', payload);
  },
  updateKeyword({ commit }, value) {
    commit('UPDATE_KEYWORD', value);
  },
  updateFacetFilters({ commit }, value) {
    commit('UPDATE_FACET_FILTERS', value);
  },
};

const getters = {
  getStockById: (state) => (id) => state.globalStocks.filter((stock) => stock.objectID === id),
};

export default {
  state,
  mutations,
  actions,
  getters,
};

function storeJSON(data, name, source) {
  const stringJSON = JSON.stringify(data);
  localStorage.setItem(name, stringJSON);
}

function readJSON(name) {
  const parsedData = JSON.parse(localStorage.getItem(name));
  return parsedData || [];
}



// WEBPACK FOOTER //
// ./src/store/modules/stocks/index.js